import { render } from "./facebook.svg?vue&type=template&id=0b9ce8b0"
const script = {}
script.render = render

export default script